
import React from "react";
import { damageReportData } from "@/data/damageReportData";

// Import components
import DamageReportHeader from "./damage-report/DamageReportHeader";
import DamageTotalOverview from "./damage-report/DamageTotalOverview";
import DamageReasons from "./damage-analysis/DamageReasons";
import SupplierAnalysis from "./damage-analysis/SupplierAnalysis";
import BrandAnalysis from "./damage-analysis/BrandAnalysis";
import TopDamageProducts from "./damage-analysis/TopDamageProducts";

const DamageReport: React.FC = () => {
  return (
    <div className="space-y-8">
      <DamageReportHeader />
      
      {/* 1. Total Overview */}
      <DamageTotalOverview
        totalDamageOrders={damageReportData.totalOverview.totalDamageOrders}
        uniqueDamagedProducts={damageReportData.totalOverview.uniqueDamagedProducts}
        averageMonthlyDamage={damageReportData.totalOverview.averageMonthlyDamage}
      />

      {/* 2. Top 5 Reasons for Damage */}
      <DamageReasons damageReasons={damageReportData.damageReasons} />

      {/* 3. Supplier Analysis */}
      <SupplierAnalysis supplierAnalysis={damageReportData.supplierAnalysis} />

      {/* 4. Brand Analysis */}
      <BrandAnalysis brandAnalysis={damageReportData.brandAnalysis} />

      {/* 5. Top Products with Damage Cases */}
      <TopDamageProducts products={damageReportData.topDamageProducts} />
    </div>
  );
};

export default DamageReport;
